module.exports = '<svg width="48" height="32" viewBox="0 0 48 32"><path d="M23.773 10.667A5.335 5.335 0 0 0 18.434 16a5.335 5.335 0 0 0 10.667 0 5.331 5.331 0 0 0-5.328-5.333zM23.728 0C14.469 0 5.581 5.624.533 14.683l-.384.688c-.211.379-.2.987.024 1.36l.405.672C5.943 26.27 15.029 32 23.727 32c8.661 0 17.296-5.355 23.104-14.323l.467-.723c.261-.397.267-1.048.016-1.451l-.456-.728C40.991 5.386 32.562-.001 23.727-.001zm.043 26.667c-5.893 0-10.669-4.776-10.669-10.667S17.878 5.333 23.771 5.333c5.888 0 10.664 4.776 10.664 10.667s-4.776 10.667-10.664 10.667z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/eye-1.js
// module id = 1134
// module chunks = 14